import axios from 'axios'
import eventBus from './eventBus'

let pending = 0
let timer = null

function startLoading() {
  if (pending === 0) {
    timer = setTimeout(() => {
      eventBus.emit('loading', true)
    }, 500)
  }
  pending++
}

function stopLoading() {
  pending--
  if (pending <= 0) {
    pending = 0
    clearTimeout(timer)
    eventBus.emit('loading', false)
  }
}

const instance = axios.create()

instance.interceptors.request.use(config => {
  startLoading()
  return config
}, error => {
  stopLoading()
  return Promise.reject(error)
})

instance.interceptors.response.use(response => {
  stopLoading()
  return response
}, error => {
  stopLoading()
  return Promise.reject(error)
})

export default instance